import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, MenuItem, Select, Stack, Typography } from "@mui/material";
import { VIEW } from "../../../utils/breakpoint";
import { GridCloseIcon } from "@mui/x-data-grid";
import sweeping from "../../../assets/cleaning/sweeping-icon.png";
import mopping from "../../../assets/cleaning/dry-mopping-icon.png";
import vacuuming from "../../../assets/cleaning/vacuuming-icon.png";
import scrubbing from "../../../assets/cleaning/scrubbing-icon.png";
import { COLOR } from "../../../utils/colors";
import { useEffect, useState } from "react";
import { ArrowBack, ArrowLeft, Check, ChevronLeft, KeyboardArrowDown, KeyboardDoubleArrowRight, Place } from "@mui/icons-material";
import { parseAsArrayOf, parseAsBoolean, parseAsString, useQueryState } from "nuqs";
import { CLEANING_SUCCESS_DIALOG_QUERY_PARAM, SELECTED_ZONE_QUERY_PARAM, SHOW_ZONE_QUERY_PARAM } from "../../../utils/const";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentFloor } from "../../../store/map/mapSlice";
import { center, points } from "@turf/turf";
import { polygonCoordinateFixer } from "../../../components/RobotMap/helpers/cleaning-map-helper";
import successCleaning from "../../../assets/cleaning/success-clean.png";
import { useMe } from "../../../hooks/user";
import { useCreateCleaningJobMutation, useCreateCleaningTaskMutation, useListAvailableZones } from "../../../hooks/cleaning";
import MapLevelIcon from "../../../components/icons/MapLevelIcon";
import { MapLevelType } from "../../../components/RobotMap/RobotMap";
import { MapType } from "../../../hooks/map.type";
import { set } from "date-fns";
import ZoneSelectedDialog from "./cleaning/ZoneSelectedDialog";
import SweepIcon from "../../../components/icons/SweepIcon";
import TrashIcon from "../../../components/icons/TrashIcon";
import { getProfile } from "../../../utils/api";
import { useListMap } from "../../../hooks/map";
import { showErrorToast } from "../../../utils/utils";
import { useCountdown } from "../../../lib/utils";

export const cleaningOptions = [
  {
    label: "Sweeping",
    value: "sweeping",
    icon: sweeping
    // }, {
    //   label: "Dry Mopping",
    //   value: "dry_mop",
    //   icon: mopping
  }, {
    label: "Scrubbing",
    value: "wet_mop",
    icon: scrubbing
    // }, {
    //   label: "Vacuuming",
    //   value: "vacuum",
    //   icon: vacuuming
  }
]

type FloorLevelType = {
  label: string;
  value: string;
  map_level: number;
}

const floorLevels: FloorLevelType[] = [
  { label: 'All Floors', value: 'all_floors', map_level: 0 },
  { label: 'Level 1', value: 'level_1', map_level: 1 },
  { label: 'Level 2', value: 'level_2', map_level: 2 },
  { label: 'Level 3', value: 'level_3', map_level: 3 },
  { label: 'Level 4', value: 'level_4', map_level: 4 },
  { label: 'Level 5', value: 'level_5', map_level: 5 },
  { label: 'Level 6', value: 'level_6', map_level: 6 },
  { label: 'Level 7', value: 'level_7', map_level: 7 },
  { label: 'Level 8', value: 'level_8', map_level: 8 },
]

type ZoneOption = {
  label: string;
  value: string | 'all_zones';
  floor: FloorLevelType;
  polygons?: { lng: number; lat: number }[];
}

export default function CleaningDialog({
  open,
  handleClose,
  handleCloseSuccess,
  onMapFlyToZone,
  onSuccess,
  mapLevels = []
}: {
  open: boolean;
  handleClose: () => void;
  handleCloseSuccess?: () => void;
  onMapFlyToZone?: (lng: number, lat: number) => void;
  onSuccess?: () => void;
  mapLevels?: MapType[];
}) {
  const [currentStep, setCurrentStep] = useState<number>(1);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState<boolean>(false);
  const [selectedCleaningOption, setSelectedCleaningOption] = useState<string>(cleaningOptions[0].value);
  const [selectedZones, setSelectedZones] = useQueryState(SELECTED_ZONE_QUERY_PARAM, parseAsArrayOf(parseAsString, ';').withDefault([]))
  const [isShowSuccess, setIsShowSuccess] = useQueryState(CLEANING_SUCCESS_DIALOG_QUERY_PARAM, parseAsBoolean.withDefault(false).withOptions({ clearOnDefault: true }));
  const [showZone, setShowZone] = useQueryState(SHOW_ZONE_QUERY_PARAM, parseAsBoolean.withDefault(false).withOptions({ clearOnDefault: true }));
  const { data: dataMe } = useMe();

  const { timeLeft, startTimer } = useCountdown({
    onFinish: () => {
      handleCloseDialog()
    },
    timeInterval: 100
  })

  const handleSuccessCreateTask = () => {
    setIsShowSuccess(true);
    setSelectedCleaningOption('');
    onSuccess?.();
    setSelectedZones([]);

    startTimer(50)
  }

  const organisationId = dataMe?.organisation || '';
  // const { trigger: submitCleanTask } = useCreateCleaningTaskMutation({
  //   organisation_id: organisationId,
  //   onSuccess: () => handleSuccessCreateTask
  // });

  const { trigger: submitCreateJob, isLoading: isSubmitting } = useCreateCleaningJobMutation({
    organisation_id: organisationId,
    onSuccess: () => handleSuccessCreateTask(),
    onError: (data) => {
      if (!data) {
        return
      }
      const errMessage = data.response?.data?.error || data.message || "Something went wrong"
      if (errMessage.includes("undefined")) {
        return
      }
      showErrorToast(errMessage)

    }
  })

  const organisation_id = getProfile()?.organisation
  const { data } = useListAvailableZones({
    organisation_id,
  });
  // const zoneOptions = mockZoneOptions;
  const zoneOptions = data?.data || []
  const { data: dataListMaps } = useListMap({
    page_size: 100
  })

  const listMaps = dataListMaps?.data || []

  const findMap = (map_uuid?: string) => {
    if (!map_uuid) {
      return undefined
    }
    return listMaps.find((data) => data.map_uuid === map_uuid)
  }

  const isDisableConfirm = selectedCleaningOption === '' || selectedZones.length === 0;
  const handleSubmit = () => {
    submitCreateJob({
      areas: selectedZones,
      cleaning_type: selectedCleaningOption
    })
  }

  const handleCloseDialog = () => {
    setSelectedZones([])
    setSelectedCleaningOption('')
    handleCloseSuccess?.()
    setIsShowSuccess(false)
  }

  useEffect(() => {
    if (!open) {
      return
    }

    setShowZone(true);
  }, [open, selectedZones, selectedCleaningOption]);

  useEffect(() => {
    if (!showConfirmationDialog) {
      setCurrentStep(1);
    }
  }, [showConfirmationDialog]);

  useEffect(() => {
    if (!open) {
      setCurrentStep(1);
      return
    }
  }, [open]);

  const handleNextFirstStep = () => {
    if (selectedZones.length === 0) {
      return
    }
    setCurrentStep(2);
    setShowConfirmationDialog(true);
  }

  const findZone = (zoneId: string) => {
    return zoneOptions.find((zone) => zone.uuid === zoneId);
  }

  useEffect(() => {
    if (currentStep && selectedZones.length === 0) {
      setCurrentStep(1);
    }
  }, [currentStep]);


  const errorJobCheck = () => {
    if (!selectedCleaningOption || selectedZones.length === 0) {
      return []
    }

    const errResult: { message: string, zone: string }[] = []
    const cleaningTypeLabel = cleaningOptions.find((data) => data.value === selectedCleaningOption)?.label

    selectedZones.forEach((zoneId) => {
      const zone = findZone(zoneId)
      if (!zone) {
        errResult.push({
          message: "Invalid Zone",
          zone: zoneId
        })
        return
      }
      if (zone?.jobs.length === 0) {
        errResult.push({
          message: zone.area_name + " is not support this cleaning type (" + cleaningTypeLabel + ")",
          zone: zoneId
        })
        return
      }

      const findJob = zone.jobs.find((data) => data.cleaning_type === selectedCleaningOption)
      if (!findJob) {
        errResult.push({
          message: zone.area_name + " is not support this cleaning type (" + cleaningTypeLabel + ")",
          zone: zoneId
        })
      }
    })

    return errResult
  }

  const onCloseConfirmationDialog = () => {
    setShowConfirmationDialog(false);
    setCurrentStep(1);
    setSelectedCleaningOption(cleaningOptions[0].value)
  }

  return (
    <div>
      {open && !isShowSuccess && (
        <>
          {currentStep === 1 && (
            <>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  position: 'absolute',
                  top: '16px',
                  left: '16px',
                  backgroundColor: `rgba(255, 255, 255, 0.45)`,
                  backdropFilter: 'blur(10px)',
                  color: COLOR.black,
                  padding: '32px',
                  fontFamily: "Poppins, sans-serif",
                  borderRadius: '8px',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <IconButton onClick={handleClose}>
                    <ChevronLeft />
                  </IconButton>
                  <Typography sx={{ fontWeight: 600, fontSize: '24px' }}>
                    Select An Area to Clean
                  </Typography>
                </Box>
                <Typography sx={{ fontWeight: 500, ml: '48px', fontSize: '16px', marginTop: '8px' }}>
                  Please tap on the zones to select the area
                </Typography>
              </Box>

              <ZoneSelectedDialog />

              <Box
                sx={{
                  position: 'absolute',
                  bottom: '24px',
                  left: '40%',
                  right: '40%',
                  display: selectedZones.length === 0 ? 'none' : 'flex',
                  opacity: selectedZones.length === 0 ? 0 : 1,
                  transition: 'all 0.3s ease-in-out',
                }}
              >
                <Button
                  variant="contained"
                  size="large"
                  sx={{
                    minWidth: '200px',
                    fontSize: '28px'
                  }}
                  fullWidth
                  onClick={handleNextFirstStep}
                  disabled={selectedZones.length === 0}
                >
                  Next <KeyboardDoubleArrowRight />
                </Button>
              </Box>
            </>
          )}

          <Dialog
            open={showConfirmationDialog}
            onClose={() => onCloseConfirmationDialog()}
            maxWidth={undefined}
            sx={(theme) => ({
              // [theme.breakpoints.up(VIEW.TABLET)]: {
              //   '& .MuiDialog-paper': {
              //     minWidth: '900px',
              //     width: '90%',
              //     maxWidth: '90%'
              //   }
              // },
              '& .MuiDialog-paper': {
                minWidth: '90%',
                width: '100%',
                // maxWidth: '90%'
              }
            })}
          >
            <DialogContent>
              <Box>
                <Typography
                  sx={(theme) => ({
                    [theme.breakpoints.up(VIEW.TABLET)]: {
                      fontSize: '24px',
                    },
                    fontWeight: 600,
                    fontSize: '18px',
                    mb: 2
                  })}
                >
                  Selected Zones
                </Typography>
                <Box
                  sx={(theme) => ({
                    [theme.breakpoints.up(VIEW.TABLET)]: {
                      gridTemplateColumns: "repeat(2, minmax(120px, 1fr))"
                    },
                    [theme.breakpoints.up(VIEW.BIG_TABLET)]: {
                      gridTemplateColumns: "repeat(3, minmax(120px, 1fr))"
                    },
                    maxHeight: '35dvh',
                    overflowY: 'auto',
                    mb: 2,
                    display: 'grid',
                    gap: '16px',
                    gridTemplateColumns: "repeat(1, minmax(120px, 1fr))"
                  })}
                >
                  {selectedZones.map((zone, index) => (
                    <Box key={index} sx={{ padding: '32px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: '#FAFAFA', borderRadius: '8px' }}>
                      <SweepIcon />
                      <Box sx={{ ml: '24px', display: 'flex', flex: 'auto', flexDirection: 'column', justifyContent: 'center' }}>
                        <Typography sx={{ fontSize: '20px', fontWeight: 600 }}>
                          {findZone(zone)?.area_name || 'Unknown Zone'}
                        </Typography>
                        <Typography sx={{ fontSize: '16px', fontWeight: 400, color: COLOR.gray[700] }}>
                          {findMap(findZone(zone)?.map)?.map_name_display || 'Unknown Floor'}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px',
                          fontSize: '28px',
                          cursor: 'pointer',
                          color: COLOR.accent.danger,
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          const newSelectedZones = selectedZones.filter((z) => z !== zone);
                          if (newSelectedZones.length === 0) {
                            onCloseConfirmationDialog()
                          }
                          setSelectedZones(newSelectedZones);
                        }}
                      >
                        <TrashIcon />
                      </Box>
                    </Box>
                  ))}
                </Box>
              </Box>
              <Box>
                <Typography
                  sx={(theme) => ({
                    [theme.breakpoints.up(VIEW.TABLET)]: {
                      fontSize: '24px',
                    },
                    fontWeight: 600,
                    fontSize: '18px',
                    mb: 2
                  })}
                >
                  Select Cleaning Mode
                </Typography>
                <Box
                  sx={(theme) => ({
                    [theme.breakpoints.up(VIEW.TABLET)]: {
                      display: 'flex',
                    },
                    display: 'grid',
                    gridTemplateColumns: "repeat(2, minmax(120px, 1fr))",
                    alignItems: 'center',
                    gap: 2,
                    mb: 2
                  })}>
                  {cleaningOptions.map((option, index) => (
                    <Box
                      key={option.value + '-' + index}
                      sx={(theme) => ({
                        [theme.breakpoints.up(VIEW.TABLET)]: {
                          height: '130px',
                        },
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        p: 2,
                        border: `1px solid ${selectedCleaningOption === option.value ? COLOR.accent.blue : COLOR.lightGray}`,
                        borderRadius: "8px",
                        backgroundColor: selectedCleaningOption === option.value ? "#0091FF0D" : "#FAFAFA",
                        color: selectedCleaningOption === option.value ? COLOR.accent.blue : COLOR.black,
                        cursor: "pointer",
                        '&:hover': {
                          borderColor: COLOR.accent.blue,
                        },
                        aspectRatio: '1/1',
                        height: 'auto',
                        justifyContent: 'center',
                      })}
                      onClick={() => setSelectedCleaningOption(option.value)}
                    >
                      <Box
                        sx={(theme) => ({
                          [theme.breakpoints.up(VIEW.TABLET)]: {
                            width: "100px",
                            height: "100px",
                          },
                          width: "64px",
                          height: "64px",
                          objectFit: 'scale-down',
                          mb: 1
                        })}
                      >
                        <img src={option.icon} alt={option.label} style={{ width: "100%", height: "100%", objectFit: "scale-down", marginBottom: "8px" }} />
                      </Box>
                      <Typography variant="body1" sx={{ color: "currentColor", fontWeight: "500", fontFamily: "Poppins, Roboto" }}>
                        {option.label}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
              {errorJobCheck().length > 0 && (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px', paddingBlock: '10px' }}>
                  {errorJobCheck().map((error, index) => (
                    <Typography key={index} sx={{ color: COLOR.accent.danger }}>
                      {error.message}
                    </Typography>
                  ))}
                </Box>
              )}
              <Box sx={(theme) => ({
                [theme.breakpoints.up(VIEW.TABLET)]: {
                  flexDirection: 'row'
                },
                display: 'flex',
                flexDirection: 'column-reverse',
                alignItems: 'center',
                gap: '12px'
              })}>
                <Button
                  variant="contained"
                  size="large"
                  sx={(theme) => ({
                    minWidth: '200px',
                    fontSize: '18px',
                    backgroundColor: '#979797',
                    color: COLOR.white,
                    '&:hover': {
                      backgroundColor: '#7a7a7a',
                    },
                    [theme.breakpoints.up(VIEW.BIG_TABLET)]: {
                      fontSize: '28px',
                    }
                  })}
                  fullWidth
                  onClick={() => onCloseConfirmationDialog()}
                  disableElevation
                >
                  Back To Selection
                </Button>
                <Button
                  variant="contained"
                  size="large"
                  sx={(theme) => ({
                    minWidth: '200px',
                    fontSize: '18px',
                    [theme.breakpoints.up(VIEW.BIG_TABLET)]: {
                      fontSize: '28px',
                    }
                  })}
                  fullWidth
                  onClick={handleSubmit}
                  disabled={isDisableConfirm || isSubmitting || errorJobCheck().length > 0}
                >
                  {isSubmitting && (
                    <CircularProgress size={20} sx={{ mr: 2 }} />
                  )}
                  Start Now
                </Button>
              </Box>
            </DialogContent>
          </Dialog>
        </>
      )}
      {isShowSuccess && (
        <Dialog open={isShowSuccess} onClose={handleCloseDialog}>
          <DialogContent>
            <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", m: 1, mr: 2 }}>
              <IconButton onClick={handleCloseDialog}>
                <GridCloseIcon sx={{ color: "#000", fontSize: "20px" }} />
              </IconButton>
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", px: 4, pt: '20px', pb: '40px', gap: 2 }}>
              <img src={successCleaning} alt="Success" style={{ width: "218.5px", height: "156.5px", objectFit: "scale-down" }} />
              <Typography sx={{ fontSize: '20px', mt: '27px', color: "#12B76A", fontWeight: "600", fontFamily: "Poppins, Roboto", textAlign: "center" }}>
                Cleaning Task Scheduled Successfully!
              </Typography>
              <Typography sx={{ fontSize: '14px', color: "#000", fontWeight: "500", fontFamily: "Poppins, Roboto", textAlign: "center" }}>
                Thank you for scheduling your cleaning with us! Your task will begin shortly.
              </Typography>
            </Box>
            <LinearProgress variant="determinate" value={timeLeft !== undefined ? (timeLeft) : 0} />
          </DialogContent>
        </Dialog>
      )}
    </div>
  )
}